import { DateFormatter } from '@repo/toolkit/date'

import { ArrivalAndDeparture } from './arrival-and-departure'

export class ArrivalAndDepartureProperties {
  static getLabel(ad: ArrivalAndDeparture) {
    const output: string[] = []

    if (ad.coachCompany?.name) output.push(ad.coachCompany.name)
    if (ad.fromTo) output.push(ad.fromTo)
    if (ad.numberOfSeats) output.push(`${ad.numberOfSeats} seats`)
    if (ad.validUntil) output.push(`valid until ${DateFormatter.DDMMYYYY(ad.validUntil)}`)

    return output.join(' - ')
  }
}
